import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { InjectTokenInterceptorService } from '../interceptors/inject-token-interceptor.service';
import { LogoutInterceptorService } from '../interceptors/logout-interceptor.service';
import { InjectCurrentSiteInterceptorService } from '../interceptors/inject-current-site-interceptor.service';

export const InterceptorsProvider = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: InjectTokenInterceptorService,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: InjectCurrentSiteInterceptorService,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: LogoutInterceptorService,
    multi: true,
  },
];
